import React from "react";
import { Space, Table, Tag } from "antd";
import TableColumnLoader from "../../../components/loader/TableColumnLoader";
import SearchInput from "../../../components/utils/SearchInput";
import {
  dateFormatterUI6,
  replaceString,
  stringSorter,
} from "../../../utils/helpers/dataHelper";
import UpdateDropDown from "./UpdateDropDown";

const AntTable = ({
  documentList,
  handleApproval,
  handleView,
  statusState,
  handleSearch,
  handleStatusUpdate,
}) => {
  const columns = [
    {
      title: "Pathfinder",
      key: "1",
      render: (record) => (
        <div className="flex">
          <img
            className="w-10 h-10 rounded-full"
            src={record.actionPerformedBy.profileImage}
            alt={record.actionPerformedBy.username}
          />
          <div className="pl-3">
            <div className="text-base font-semibold name">
              {record.actionPerformedBy.fullName}
            </div>
            <div className="font-sm text-gray-500">
              {record.actionPerformedBy.emailAddress}
            </div>
          </div>
        </div>
      ),
    },
    {
      title: "Created Date",
      dataIndex: "createdDate",
      key: "createdDate",
      render: (createdDate) => <span>{dateFormatterUI6(createdDate)}</span>,
      sorter: (a, b) => stringSorter(a.createdDate, b.createdDate),
    },
    {
      title: "Document Name",
      dataIndex: "documentType",
      key: "documentType",
      render: (documentType) => (
        <div className="flex items-center">{replaceString(documentType)}</div>
      ),
    },
    {
      title: "Document Fee",
      dataIndex: "documentFee",
      key: "documentFee",
    },
    {
      title: "Transaction Status",
      dataIndex: "paymentStatus",
      key: "paymentStatus",
      render: (paymentStatus) => (
        <div className="flex items-center">{paymentStatus}</div>
      ),
    },
    {
      title: "Status",
      key: "status",
      render: (record) => (
        <div className="flex items-center">
          {record.approved ? (
            <div className="font-bold rounded-full text-green-800 mr-2">
              APPROVED
            </div>
          ) : (
            <div className="font-bold rounded-full text-red-800 mr-2">
              PENDING
            </div>
          )}
        </div>
      ),
    },
    {
      title: "Update Status",
      key: "action",
      render: (_, record) => (
        <Space size="middle">
          <UpdateDropDown
            record={record}
            handleStatusUpdate={(value) => handleStatusUpdate(record, value)}
          />
        </Space>
      ),
    },
    {
      title: "Action",
      key: "action",
      render: (_, record) => (
        <Space size="middle">
          {statusState[record.id] ? (
            <TableColumnLoader />
          ) : (
            <>
              {record.approved ? (
                <Tag
                  color={"green"}
                  className="cursor-pointer"
                  onClick={() => handleApproval(record)}
                >
                  Decline
                </Tag>
              ) : (
                <Tag
                  color={"red"}
                  className="cursor-pointer"
                  onClick={() => handleApproval(record)}
                >
                  Approve
                </Tag>
              )}
            </>
          )}

          <Tag
            color={"blue"}
            className="cursor-pointer"
            onClick={() => handleView(record)}
          >
            View
          </Tag>
        </Space>
      ),
    },
  ];
  return (
    <div>
      <div className="flex justify-between items-center pb-2 bg-white dark:bg-gray-800">
        <div></div>
        <SearchInput handleSearch={(value) => handleSearch(value)} />
      </div>
      <Table
        columns={columns}
        pagination={{}}
        dataSource={documentList}
        scroll={{
          x: 1500,
        }}
        sticky
      />
    </div>
  );
};

export default AntTable;
